import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('Controlling');

export const MOVEMENTTYPE_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('sapCode', 'Entity.MovementType.SapCode')
    .required()
    .minLength(1)
    .maxLength(3)
    .build(),
  FieldBuilder
    .text('description', 'Entity.MovementType.Description')
    .required()
    .minLength(1)
    .maxLength(200)
    .build(),
];

export const MOVEMENTTYPE_CONFIG = {
  entityName: 'MovementType',
  localizationKey: 'Controlling::Entity.MovementType',
  fields: MOVEMENTTYPE_FIELDS,
  permission: 'ControllingSap.MovementTypes',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.SAP + MENU_NAME_SUFFIX,
};
